export const USER_REVIEW_MILESTONES = [1, 5, 10, 25, 50, 100];

export const getNextUserMilestone = (count, milestones = USER_REVIEW_MILESTONES) => {
  const safeCount = Number(count) || 0;
  return milestones.find((milestone) => milestone > safeCount) || null;
};

export const getUserProgressPercent = (count, milestones = USER_REVIEW_MILESTONES) => {
  const safeCount = Number(count) || 0;
  const nextMilestone = getNextUserMilestone(safeCount, milestones);
  if (!nextMilestone) {
    return 100;
  }
  // Show progress from 0 to the next milestone
  // e.g., if you have 10 reviews and next milestone is 25, show 10/25 = 40%
  if (nextMilestone <= 0) {
    return 0;
  }
  return Math.max(0, Math.min(100, (safeCount / nextMilestone) * 100));
};


